'use strict';
var Backbone = require('dibs-backbone');
var SoaModel = require('bunsen/models/SoaModel');
var newsy = require('newsy');
module.exports = SoaModel.extend({
    defaults: {
        recipientType: 'TO',
        readMessage: 'N'
    },
    relations: [
        {
            key: 'recipientDetails',
            relatedModel : newsy.getConstructor.bind(newsy, 'ConversationMember'),
            type: Backbone.One
        }
    ]
}, {
    newsy: {
        builds: ['ConversationMember'],
        name: 'MessageRecipient'
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/usercomm/MessageRecipient.js
// module id = 72
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56 57